import React, { useEffect, useState } from "react";
import {
  billingCodeOptions,
  healthIssuesOptions,
} from "../../../../constants/dummyData";
import Select from "react-select";
import { getFullName, notify } from "../../../../util/helpers";
import { DatePicker, DateRangePicker } from "rsuite";
import { ReactComponent as CalendarIcon } from "../../../../assets/icons/calendar.svg";
import { useSelector, useDispatch } from "react-redux";
import PatientLoader from "../../../common/PatientLoader";
import "../../patient/PatientStyles.css";
import {
  alterBHIManagers,
  alterSinglePatient,
  inviteBHIPatientLogic,
  setDiagnosisDataLogic,
} from "../../../../store/features/patient/patientSlice";

import {
  alterBHIDiagnosis,
  getPatientBHIDataLogic,
} from "../../../../store/features/patient/bhiSlice";
import moment from "moment";

const InvitedWalkInOffCanvas = ({ closeModal, updateMode = false }) => {
  const { beforeToday } = DateRangePicker;
  const { bhiLoading, bhiData } = useSelector((state) => state.bhi);
  const [initialVisit, setInitialVisit] = useState(null);
  const [consent, setConsent] = useState(null);
  const [customNotes, setCustomNotes] = useState(null);
  const [bhiManagers, setBhiManagers] = useState([]);
  const [selectedBHIManagers, setSelectedBhiManagers] = useState([]);
  const [healthIssues, setHealthIssues] = useState(healthIssuesOptions[0]); //* Change this to be an array when isMulti is enabled.
  const [billingCode, setBillingCode] = useState(billingCodeOptions[0]);
  const dispatch = useDispatch();
  const { staffDataLoading, staffData, selectedClinic, user } = useSelector(
    (state) => state.app
  );
  const { loading, singlePatientData } = useSelector((state) => state.patient);

  useEffect(() => {
    if (loading) {
      return;
    }
    if (!staffDataLoading && staffData.length > 0) {
      const tempSelectedBHIManagers = [];
      const clinicians = [
        // selectedClinic?.clinic_admin, // Remove clinic admin
        ...selectedClinic?.clinical_staff,
      ];
      const tempStaff = staffData
        .map((staff) => {
          if (
            singlePatientData?.shared_with_clinical_staff?.includes(staff?.id)
          ) {
            tempSelectedBHIManagers.push({
              label: getFullName(staff),
              value: staff,
            });
          }
          if (clinicians?.includes(staff?.id)) {
            return {
              label: getFullName(staff),
              value: staff,
            };
          }
        })
        .filter((item) => {
          if (item) {
            return item;
          }
        });
      setBhiManagers(tempStaff);
      // setSelectedBhiManagers([tempStaff[0], ...tempSelectedBHIManagers]); // Remove Clinic Admin
      setSelectedBhiManagers([...tempSelectedBHIManagers]);
    }
  }, [loading, bhiLoading, staffDataLoading, staffData,singlePatientData]);

  useEffect(() => {
    //! Is this right?
    if (!bhiLoading) {
      setHealthIssues({ label: bhiData?.diagnosis, value: bhiData?.diagnosis });
      setBillingCode({
        label: bhiData?.billing_code,
        value: bhiData?.billing_code,
      });
    }
  }, [bhiLoading]);

  const handleManagerChange = (e) => {
    setSelectedBhiManagers([...e]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // if (!("id" in bhiData)) {
    //   notify("This patient is not BHI eligible!", "error");
    //   return false;
    // }
    let method = "patch";

    const payload = {
      billing_code: billingCode?.value,
      diagnosis: healthIssues?.value,
      bhi_manager: "Check Shared With Field",
      patient: singlePatientData?.id,
    };

    if (!updateMode) {
      payload["consent_information"] = "Agreed";
      //console.log("initialVisit",initialVisit)
      payload["enrollment_date"] = moment(initialVisit).format("yyyy-MM-DD");
      method = "post";
    }
    //console.log("selectedBHIManagers",selectedBHIManagers)
    const tempManagers = selectedBHIManagers
      .filter((manager) => manager?.value?.role !== "CLINIC_ADMIN")
      .map((manager) => {
        return manager?.value?.id;
      })
      // .filter((item) => item !== user?.id); ----commenting this as new requirement is to show logged in user also if he is being assigned.
     // console.log("tempManagers",tempManagers)  
    inviteBHIPatientLogic(payload, bhiData?.id, method)
      .then((res) => {
        //*Status code is 201 when new BHI data is posted, 200 on patch.
        if (res.status === 201 || res.status === 200) {
          dispatch(getPatientBHIDataLogic(singlePatientData?.id));
          if (customNotes) {
            dispatch(
              setDiagnosisDataLogic({
                diagnosis: healthIssues?.value,
                notes: customNotes,
                patient: singlePatientData?.id,
                added_by: user?.id,
              })
            );
          }
          dispatch(alterBHIDiagnosis(healthIssues?.value));
          alterBHIManagers(singlePatientData?.id, {
            shared_with_clinical_staff: tempManagers,
          })
            .then((res) => {
              if (res.status === 200) {
                dispatch(alterSinglePatient(res.data));
              }
            })
            .catch((e) => console.log("Error setting clinic staff!", e));
          notify("BHI data updated successfully!");
        }
      })
      .catch((e) => {
        console.log("error in adding bhi data", e);
        notify("Something went wrong! Try again later!", "error");
      });
    closeModal();
  };

  return (
    <div className="container-fluid">
      <h4 className="mt-5 primary-text-blue">
        {updateMode ? "Update Patient Details" : "Enroll Patient"}
      </h4>
      {staffDataLoading ? (
        <PatientLoader />
      ) : (
        <form onSubmit={handleSubmit} className="container-fluid p-2 my-3">
          {!updateMode && (
            <div className="form-group my-4">
              <label>Date of Initial Visit/Enrollment *</label>
              <DatePicker
                placeholder="MM/DD/YYYY"
                appearance="subtle"
                name="initial_visit"
                id="initial_visit"
                value={initialVisit}
                onChange={setInitialVisit}
                caretAs={CalendarIcon}
                // shouldDisableDate={beforeToday()}
                format="MM/dd/yyyy"
                oneTap
                className="custom-datepicker"
              />
            </div>
          )}

          <div className="form-group my-4">
            <label>Behavioral Health Manager *</label>
            <Select
              value={selectedBHIManagers}
              onChange={handleManagerChange}
              styles={{
                control: (baseStyles) => ({
                  ...baseStyles,
                  border: "0px",
                  borderBottom: "1px solid #94A3B8",
                  borderRadius: "0px",
                  padding: "5px",
                }),
              }}
              components={{
                IndicatorSeparator: () => null,
              }}
              placeholder="Dr. John Doe"
              classNamePrefix="select"
              name="doctor"
              isMulti
              isClearable={selectedBHIManagers?.some(
                (v) => v?.value?.id === selectedClinic?.clinic_admin
              )}
              options={bhiManagers}
            />
          </div>

          <div className="form-group my-4">
            <label>Behavioral Health Billing Codes *</label>
            <Select
              styles={{
                control: (baseStyles) => ({
                  ...baseStyles,
                  border: "0px",
                  borderBottom: "1px solid #94A3B8",
                  borderRadius: "0px",
                  padding: "5px",
                }),
              }}
              components={{
                IndicatorSeparator: () => null,
              }}
              placeholder={billingCode[0]}
              classNamePrefix="select"
              name="billingCodes"
              options={billingCodeOptions}
              // isMulti
              value={billingCode}
              onChange={setBillingCode}
              // defaultValue={billingCode[0]}
            />
          </div>

          <div className="form-group my-4">
            <label>Behavioral Health Diagnosis *</label>
            <Select
              styles={{
                control: (baseStyles) => ({
                  ...baseStyles,
                  border: "0px",
                  borderBottom: "1px solid #94A3B8",
                  borderRadius: "0px",
                  padding: "5px",
                }),
              }}
              components={{
                IndicatorSeparator: () => null,
              }}
              placeholder={healthIssuesOptions[0]}
              classNamePrefix="select"
              name="healthDiagnosis"
              options={healthIssuesOptions}
              // isMulti
              value={healthIssues}
              onChange={setHealthIssues}
              // defaultValue={healthIssuesOptions[0]}
            />
          </div>
          <div className="form-group my-4">
            <label>Notes on BH Diagnosis</label>
            <textarea
              id="notes"
              name="notes"
              placeholder="Anything special you'd like to add ...."
              className="form-control"
              rows="5"
              value={customNotes}
              onChange={(e) => {
                setCustomNotes(e.target.value);
              }}
              style={{ resize: "none" }}
            ></textarea>
          </div>
          <div>
            <div className="d-flex form-group my-2" style={{ gap: "10px" }}>
              <input
                type="checkbox"
                checked={consent}
                onChange={() => {
                  setConsent(!consent);
                }}
                required
                style={{
                  border: "1px solid #D0D5DD",
                  borderRadius: "4px",
                  width: "23px",
                }}
              />
              <small
                onClick={() => {
                  setConsent(!consent);
                }}
                style={{ color: "#475569" }}
              >
                I confirm I have discussed Behavioral Health Care Management
                Program with the patient
              </small>
            </div>
          </div>

          <div className="d-flex justify-content-center w-100 container-fluid mb-2 mt-3">
            <button
              disabled={!consent}
              className="btn primary-btn w-100"
              type="submit"
            >
              Submit
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default InvitedWalkInOffCanvas;
